import { render } from "./Lojas.vue?vue&type=template&id=50d8942a&ts=true"
import script from "./Lojas.vue?vue&type=script&lang=ts"
export * from "./Lojas.vue?vue&type=script&lang=ts"

import "./Lojas.vue?vue&type=style&index=0&id=50d8942a&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__